<div class="point-balance-root">
  <div class="header-panel">
    <div class="series-panel">
      <div class="series-title">
        {{labels.pointsTimelineLabel}}
      </div>
      <div class="series-selector">
        <div class="series-icon">
          <mat-icon>
            print
          </mat-icon>
        </div>
        <div class="series-dropdown">
          <app-filter-container [isSingleSelection]="true"
                                (selectFilterClick)="updateFilter($event)"
                                [seriesChips]="this.seriesChips"
                                [filters]="this.seriesFilter"
          ></app-filter-container>
        </div>
      </div>
    </div>
    
    <div class="vip-panel" *ngIf="pointSummary">
      <div class="vip-icon">
        <mat-icon>
          credit_card
        </mat-icon>
      </div>
      <div class="vip-name">
        {{pointSummary!.businessLevel!.description}}
      </div>
    </div>
  </div>
  <div class="points-summary">
    <app-points-summary [business]="business" [pointSummary]="pointSummary"></app-points-summary>
  </div>
  <div class="tab-selector">
    <app-date-tab-selector (selectFilterClick)="setDateRangeFilter($event)"></app-date-tab-selector>
    <div class="filter-chip">
      <span>{{ labels.filterLabel }}</span>
    </div>
    <div class="filter-area-row">
      <app-filter-area
        content
        [chipContents]="chipContents"
        [isCarousel]="false"
        [isGray]="true"
        (selectedFilter)="getFilter($event)"
      ></app-filter-area>
      <span
        *ngIf="hasActiveFilters()"
        class="clear-all"
        (click)="clearAllFilters()"
      >{{ labels.clearAllLabel }}</span>
    </div>
    <app-timeline [filters]="filters"></app-timeline>
  </div>
</div>
